<template>
  <div>
    <img
      v-if="show"
      class="i i0"
      src="https://img.yzcdn.cn/upload_files/2020/08/14/Fnxfesi_N6fapxRIBttn79pyM5Bt.png"
      @click="lock"
    />
    <Num
      :show.sync="showNum"
      :type="type"
      :err-msg.sync="errMsg"
      @on-change="inputEnd"
      @on-forget="forget"
    />
  </div>
</template>

<script>
import Num from '@/pages/userCenter/route/parentLock/components/num.vue'
import { getCookie, setCookie } from '@/static/js/zjs.js'
export default {
  components: {
    Num
  },
  props: {
    show: false
  },
  data() {
    return {
      showNum: false,
      errMsg: '',
      type: 'input'
    }
  },
  methods: {
    lock() {
      this.showNum = true
    },
    // 输入结束
    inputEnd(val) {
      if (this.type === 'input') {
        this.setClose(val.join(''))
      }
    },
    // 忘记密码
    forget() {
      window.location.href = '/cms/webapp/home/info/verifyPhone.html'
    },
    setClose(password) {
      const openid = this.$store.openid
      // 关闭
      u.fet('/cms/weixin/user/parentUnLock', { password, openid }).then((res) => {
        if (res === 'OK') {
          setCookie('hwViewLock', 0)
          window.location.reload()
        } else {
          this.errMsg = '密码错误，请重新输入'
          setTimeout(() => {
            this.errMsg = ''
          }, 1500)
        }
      })
    }
  }
}
</script>

<style scoped>
.i0 {
  width: 100%;
  position: absolute;
  top: 0;
}
</style>
